<template>
  <div class="macro">
    <div class="list" v-if="type === 'macro'">
      <div
        class="fields"
        v-for="(key, index) in macroValue.keyOrder"
        :key="key + index"
      >
        <md-field class="field" v-if="typeof key === 'string'">
          <c-mouse-virtual-keyboard
            class="key-input"
            v-if="activeIndex === index"
            :selectedKey="macroValue.keyOrder[index]"
            :text="getKey(key)"
            @change="onKeyChange(index, $event)"
            showMouse
            downAndUp
          />
          <md-input
            v-else
            :value="getKey(key)"
            readonly="readonly"
            class="key-input"
            @mouseover="activeIndex = index"
          ></md-input>
          <i
            v-show="state !== 'record'"
            class="key-remove iconfont iconclose"
            @click="onKeyRemove(index)"
          />
        </md-field>
        <div v-else class="xy">
          <md-field class="number">
            <span class="md-prefix">X</span>
            <md-input
              class="number-input"
              @change="
                macroValue.keyOrder[index].x = Number($event.target.value)
              "
              :value="macroValue.keyOrder[index].x"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9]/g, '');
              this.value = this.value > 127 ? 127 : this.value;
              this.value = this.value < -127 ? -127 : this.value;"
            ></md-input>
          </md-field>
          <md-field class="number">
            <span class="md-prefix">Y</span>
            <md-input
              class="number-input"
              @change="
                macroValue.keyOrder[index].y = Number($event.target.value) * -1
              "
              :value="macroValue.keyOrder[index].y * -1"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9]/g, '');
              this.value = this.value > 127 ? 127 : this.value;
              this.value = this.value < -127 ? -127 : this.value;"
            ></md-input>
          </md-field>
          <i
            v-show="state !== 'record'"
            class="key-remove iconfont iconclose"
            @click="onKeyRemove(index)"
          />
        </div>

        <md-menu
          md-align-trigger
          v-if="index === macroValue.keyOrder.length - 1"
        >
          <i
            v-show="state !== 'record'"
            md-menu-trigger
            class="key-add iconfont iconplus-o"
          />
          <md-menu-content>
            <md-menu-item @click="onKeyAdd">
              {{ $t("mouse.button") }}
            </md-menu-item>
            <md-menu-item @click="onXYAdd">
              {{ $t("mouse.coordinates") }}
            </md-menu-item>
          </md-menu-content>
        </md-menu>
        <template v-else>
          -
          <md-field class="field time">
            <md-input
              v-model="macroValue.pressTime[index]"
              @blur="onIntervalInput(index, $event)"
              :disabled="state === 'record'"
              class="time-input"
            ></md-input>
            <span class="md-suffix">ms</span>
          </md-field>
          —
        </template>
      </div>
    </div>
    <div class="list" v-if="type === 'hotkey'">
      <a-radio-group
        :value="macroValue.keyOrder[0]"
        @change="onHotkeyChange(0, $event.target.value)"
        class="radio-group"
      >
        <a-radio class="radio" value="0x11e0"> Ctrl </a-radio>
        <a-radio class="radio" value="0x11e1"> Shift </a-radio>
        <a-radio class="radio" value="0x11e2"> Alt </a-radio>
        <a-radio class="radio" value="0x11e3"> Meta </a-radio>
      </a-radio-group>
      <div class="hotkey">
        <i class="iconfont iconplus-o" />
        <md-field class="field">
          <md-select
            :value="macroValue.keyOrder[1]"
            @md-selected="onHotkeyChange(1, $event)"
            class="key-select"
          >
            <template v-for="(value, key) in hotKeys">
              <md-option v-if="value" :value="value" :key="'key' + value">
                {{ key.replace("Key", "").replace("Digit", "") }}
              </md-option>
            </template>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="buttons" @mousedown.stop @mouseup.stop>
      <md-field class="macro-field">
        <md-select
          v-model="macroIndex"
          :disabled="state === 'record'"
          class="macro-select"
          @md-selected="onMacroChange"
          :placeholder="$t('keyboard.macro.select')"
        >
          <template v-for="(macro, index) in macroData">
            <md-option :value="index" :key="'macro_key' + index">
              {{ macro.macro_name }}
            </md-option>
          </template>
        </md-select>
      </md-field>
      <md-field class="macro-name">
        <md-input
          class="input"
          v-model="macroName"
          @blur="onSave"
          @keypress.enter="onSave"
        ></md-input>
      </md-field>
      <md-field class="all-time">
        <md-input
          class="input"
          :value="allInterval"
          @blur="onAllIntervalInput"
          @keypress.enter="onAllIntervalInput"
          :disabled="state === 'record'"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <a-radio-group class="radio-group" value="none" size="large">
        <a-radio-button :disabled="state === 'record'" @click="onAddMacro">
          {{ $t("keyboard.macro.add") }}
        </a-radio-button>
        <a-radio-button
          :disabled="state === 'record' || macroIndex < 0"
          @click="onRemove"
        >
          {{ $t("keyboard.macro.remove") }}
        </a-radio-button>
        <a-radio-button
          :disabled="macroIndex < 0"
          @click="onRecord"
          v-if="state === 'stop'"
        >
          {{ $t("keyboard.macro.record") }} ●
        </a-radio-button>
        <a-radio-button
          :disabled="macroIndex < 0"
          :class="{ active: state === 'record' }"
          @click="state = 'stop'"
          v-if="state === 'record'"
        >
          {{ $t("keyboard.macro.stop") }} ■
        </a-radio-button>
        <a-radio-button
          :disabled="state === 'record' || macroIndex < 0"
          :class="{ active: type === 'hotkey' }"
          @click="onTypeChange"
          v-if="false"
        >
          {{ $t("mouse.hotkey") }}
        </a-radio-button>
        <a-radio-button
          :class="{ active: saveActive }"
          :disabled="state === 'record' || macroIndex < 0"
          @click="onSave"
        >
          {{ $t("save") }}
        </a-radio-button>
      </a-radio-group>
      <a-progress
        class="progress"
        :stroke-color="{
          '0%': '#4136f1',
          '100%': '#8743ff',
        }"
        :percent="parseInt(macroValue.keyOrder.length / 0.42)"
        status="active"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { codeKeys } from "../mouse";
import { deepCopy } from "@/utils";

let hotKeys = {};

Object.keys(codeKeys).forEach((key) => {
  if (codeKeys[key].includes("0x11")) {
    hotKeys[key.replace("↓", "")] = codeKeys[key];
  }
});

export default {
  name: "CMouseMacro",
  data() {
    return {
      codeKeys,
      hotKeys,
      macroLength: 0,
      state: "stop",
      type: "macro",
      time: 0,
      activeIndex: -1,
      minInterval: 1,
      macroIndex: -1,
      macroValue: {
        keyOrder: [],
        pressTime: [],
      },
      macroName: "",
      allInterval: null,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("mouse", {
      macroData: "macroData",
      keyMatrix: "keyMatrix",
    }),
    saveActive() {
      if (this.state === "record") return false;
      if (this.macroIndex < 0) return false;
      if (
        JSON.stringify(this.macroValue) !==
        JSON.stringify(this.macroData[this.macroIndex].macroValue)
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onInit() {
      this.disabled = false;
      this.state = "stop";
      if (this.macroData?.length) {
        if (this.macroIndex < 0) {
          this.macroIndex = 0;
          this.macroValue = deepCopy(this.macroData[0].macroValue);
          this.macroName = this.macroData[0].macro_name;
        }
      }
      // this.macroLength = this.macroData.reduce((acc, item) => {
      //   return acc + item.macroValue.keyOrder.length;
      // }, 0);
    },
    onMacroChange(index) {
      if (this.macroIndex < 0) return;
      this.macroValue = deepCopy(this.macroData[index].macroValue);
      this.macroIndex = index;
      this.macroName = this.macroData[index].macro_name;
    },
    onAllIntervalInput(e) {
      let time = e.target.value;
      time = parseInt(time.replace(/[^0-9]/g, "")) || 0;
      if (time < this.minInterval) time = this.minInterval;
      if (time > 60000) time = 60000;
      this.macroValue.pressTime.fill(time);
      this.macroValue = { ...this.macroValue };
      this.allInterval = time;
      this.onSave();
    },
    onAddMacro() {
      this.state = "stop";
      this.type = "macro";
      this.macroValue = {
        keyOrder: [],
        pressTime: [],
      };
      this.macroIndex = this.macroData.length;
      let index = 0;
      while (this.macroData.findIndex((i) => i.index === index) > -1) {
        index++;
      }
      this.$store.dispatch("mouse/setMacroData", [
        ...this.macroData,
        {
          index,
          profile: 0,
          key_code: "",
          repeat: 1,
          playModel: "",
          macroValue: {
            keyOrder: [],
            pressTime: [],
          },
        },
      ]);
    },
    getKey(key) {
      const text = Object.keys(codeKeys).find((k) => codeKeys[k] === key);
      return (text || key)
        .replace("Key", "")
        .replace("Digit", "")
        .replace("Meta", "Code");
    },
    onKeyRemove(index) {
      this.macroValue.keyOrder.splice(index, 1);
      this.macroValue.pressTime.splice(index, 1);
      this.macroValue = { ...this.macroValue };
    },
    onKeyChange(index, value) {
      console.log("onKeyChange", value);
      this.macroValue.keyOrder[index] = value;
      this.macroValue = { ...this.macroValue };
    },
    onIntervalInput(index, e) {
      let time = e.target.value;
      time = parseInt(time.replace(/[^0-9]/g, "")) || 0;
      if (time < this.minInterval) time = this.minInterval;
      if (time > 60000) time = 60000;
      this.macroValue.pressTime[index] = Math.floor(time);
      this.macroValue = { ...this.macroValue };
    },
    onKeyAdd() {
      this.macroValue.keyOrder.push("0x1104");
      this.macroValue.pressTime.push(this.minInterval);
      this.macroValue = { ...this.macroValue };
    },
    onXYAdd() {
      this.macroValue.keyOrder.push({ x: 0, y: 0 });
      this.macroValue.pressTime.push(this.minInterval);
      this.macroValue = { ...this.macroValue };
    },
    onHotkeyChange(index, value) {
      this.macroValue.keyOrder[index] = value;
      this.macroValue.keyOrder[3 - index] = value.replace("0x11", "0x10");
      this.macroValue = { ...this.macroValue };
    },
    onRemove() {
      this.$confirm({
        title: this.$t("keyboard.macro.removeConfirm"),
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
        onOk: () => {
          const macroData = [...this.macroData];
          const removedMacro = macroData.splice(this.macroIndex, 1);
          const removedIndex = removedMacro[0].index;
          const removedKey = `0x${removedIndex.toString(16).padStart(2, "0")}`;
          const restoreKey = Object.keys(this.keyMatrix).find((key) => {
            const [first, , third] = this.keyMatrix[key];
            return first === "0x09" && third === removedKey;
          });
          restoreKey && this.onRestore(restoreKey);
          this.state = "stop";
          this.type = "macro";
          this.macroIndex = -1;
          this.macroValue = {
            keyOrder: [],
            pressTime: [],
          };
          (this.macroName = ""),
            this.$store.dispatch("loader/deleteMouseMacro", {
              mouseMacroData: macroData,
            });
          this.$store.dispatch("mouse/setMacroData", macroData);
        },
      });
    },
    onRestore(key) {
      const keyMatrix = {
        "0x00": ["0x01", "0x00", "0xf0", "0x00"],
        "0x02": ["0x01", "0x00", "0xf2", "0x00"],
        "0x01": ["0x01", "0x00", "0xf1", "0x00"],
        "0x0e": ["0x01", "0x00", "0xf5", "0x01"],
        "0x0f": ["0x01", "0x00", "0xf5", "0xff"],
        "0x03": ["0x01", "0x00", "0xf4", "0x00"],
        "0x04": ["0x01", "0x00", "0xf3", "0x00"],
      };
      this.$store.dispatch("mouse/setKeyMatrix", {
        ...this.keyMatrix,
        [key]: keyMatrix[key],
      });
      this.$store.dispatch("loader/changeMouseKey", {
        key_code: key,
        change_key: keyMatrix[key],
      });
    },
    onRecord() {
      this.macroValue = {
        keyOrder: [],
        pressTime: [],
      };
      this.state = "record";
      this.type = "macro";
    },
    onTypeChange() {
      this.type = this.type === "hotkey" ? "macro" : "hotkey";
      if (this.type === "hotkey") {
        if (
          this.macroValue.keyOrder.length !== 4 ||
          this.macroValue.keyOrder[0].replace("0x11", "0x10") !==
            this.macroValue.keyOrder[3] ||
          this.macroValue.keyOrder[1].replace("0x11", "0x10") !==
            this.macroValue.keyOrder[2]
        ) {
          this.macroValue.keyOrder = ["0x11e0", "0x1104", "0x1004", "0x10e0"];
        }
        this.macroValue.pressTime = [50, 50, 50, 50];
        this.macroValue = { ...this.macroValue };
      }
    },
    onSave() {
      const length = this.macroValue.keyOrder.length;
      const macroData = [...this.macroData];
      if (length > 42) {
        this.$message.info(this.$t("keyboard.macro.maxLength", [42]));
        return;
      }
      this.macroValue.pressTime[length - 1] = 50;
      // this.macroValue.pressTime[length - 1] || 50;
      macroData[this.macroIndex].macroValue = deepCopy(this.macroValue);
      this.macroName = macroData[this.macroIndex].macro_name =
        this.macroName || "M_" + macroData[this.macroIndex].index;

      for (const key in this.keyMatrix) {
        let item = this.keyMatrix[key];
        if (
          item[0] == "0x09" &&
          item[2] ==
            `0x${macroData[this.macroIndex].index
              .toString(16)
              .padStart(2, "0")}`
        ) {
          macroData[this.macroIndex].key_code = key;
          this.$store.dispatch(
            "loader/setMouseMacro",
            macroData[this.macroIndex]
          );
        }
      }

      this.$store.dispatch("mouse/setMacroData", macroData);
      this.$store
        .dispatch("loader/saveMouseMacro", this.macroData[this.macroIndex])
        .then(() => {
          this.$message.info(this.$t("loader.saveSuccess"));
        });
    },
    onKeyDown(event) {
      if (this.state === "record") {
        const downKey = codeKeys["↓" + event.code];
        if (!downKey) return;
        const downIndex = this.macroValue.keyOrder.lastIndexOf(downKey);
        const upKey = codeKeys["↑" + event.code];
        const upIndex = this.macroValue.keyOrder.lastIndexOf(upKey);
        if (downIndex === -1 || upIndex > downIndex) {
          this.macroValue.keyOrder.push(downKey);
          const time = new Date().getTime() - this.time;
          const timeIndex = this.macroValue.keyOrder.length - 2;
          if (timeIndex >= 0) {
            this.macroValue.pressTime[timeIndex] =
              time > this.minInterval ? time : this.minInterval;
          }
          this.time = new Date().getTime();
        }
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      if (this.type === "hotkey") {
        const downKey = hotKeys[event.code];
        if (!downKey) return;
        this.onHotkeyChange(1, downKey);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    onKeyUp(event) {
      if (this.state === "record") {
        const downKey = codeKeys["↑" + event.code];
        if (!downKey) return;
        this.macroValue.keyOrder.push(downKey);
        const time = new Date().getTime() - this.time;
        const timeIndex = this.macroValue.keyOrder.length - 2;
        if (timeIndex >= 0) {
          this.macroValue.pressTime[timeIndex] =
            time > this.minInterval ? time : this.minInterval;
        }
        this.time = new Date().getTime();
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      if (this.type === "hotkey") {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    onMouseDown(event) {
      if (this.state === "record") {
        const code = [
          "MouseLeft",
          "MouseRight",
          "MouseWheel",
          "MouseBack",
          "MouseForward",
        ][event.button];
        if (!code) return;
        const downKey = codeKeys["↓" + code];
        const downIndex = this.macroValue.keyOrder.lastIndexOf(downKey);
        const upKey = codeKeys["↑" + code];
        const upIndex = this.macroValue.keyOrder.lastIndexOf(upKey);
        if (downIndex === -1 || upIndex > downIndex) {
          this.macroValue.keyOrder.push(downKey);
          const time = new Date().getTime() - this.time;
          const timeIndex = this.macroValue.keyOrder.length - 2;
          if (timeIndex >= 0) {
            this.macroValue.pressTime[timeIndex] =
              time > this.minInterval ? time : this.minInterval;
          }
          this.time = new Date().getTime();
        }
      }
    },
    onMouseUp(event) {
      if (this.state === "record") {
        const code = [
          "MouseLeft",
          "MouseRight",
          "MouseWheel",
          "MouseBack",
          "MouseForward",
        ][event.button];
        if (!code) return;
        const downKey = codeKeys["↑" + code];
        this.macroValue.keyOrder.push(downKey);
        const time = new Date().getTime() - this.time;
        const timeIndex = this.macroValue.keyOrder.length - 2;
        if (timeIndex >= 0) {
          this.macroValue.pressTime[timeIndex] =
            time > this.minInterval ? time : this.minInterval;
        }
        this.time = new Date().getTime();
      }
      if (event.button !== 0) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("keyup", this.onKeyUp);
    document.addEventListener("mousedown", this.onMouseDown);
    document.addEventListener("mouseup", this.onMouseUp);

    this.onInit();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("keyup", this.onKeyUp);
    document.removeEventListener("mousedown", this.onMouseDown);
    document.removeEventListener("mouseup", this.onMouseUp);
  },
};
</script>
<style lang="scss" scoped>
.macro {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .list {
    width: 1100px;
    min-height: 250px;
    border: 1px solid $primary-color;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 30px;
    padding: 10px;

    .fields {
      @include flex-center;
      font-size: 30px;
      letter-spacing: 0;
      color: $primary-color;

      .field {
        width: 95px;
        margin: 5px 0;
        background: #333333;
        padding: 5px;
        font-size: 14px;
        position: relative;
      }

      .key-remove {
        @include flex-center;
        display: none;
        width: 25px;
        height: 25px;
        border-radius: 25px;
        background: $primary-color;
        color: #ffffff;
        position: absolute;
        right: -8px;
        top: -8px;
        cursor: pointer;
      }

      &:hover .key-remove {
        display: flex;
      }

      .key-add {
        font-size: 26px;
        margin-left: 2px;
        cursor: pointer;
      }

      .time {
        width: 80px;
        font-size: 14px;

        .md-input {
          width: 45px;
        }
      }

      .xy {
        width: 95px;
        margin: 5px 0;
        background: #333333;
        padding: 0;
        position: relative;

        .number {
          width: 100%;
          color: #717171;
          letter-spacing: 0;
          margin: 0;
          padding: 0 5px;
          height: 25px;
          min-height: 25px;
          line-height: 25px;

          .number-input {
            width: 100%;
            text-align: center;
            font-size: 16px;
            height: 25px;
            min-height: 25px;
            line-height: 25px;
          }
        }
      }
    }

    .radio-group {
      width: 120px;
      margin-left: 350px;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        justify-content: flex-start;
        background-color: #050505;
        padding: 0 10px;
        margin: 5px;
        border-radius: 5px;
      }
    }

    .hotkey {
      @include flex-center;
      height: 140px;
      margin: 40px 0 0 20px;
      border-left: 1px solid $primary-color;

      .iconfont {
        color: $primary-color;
        font-size: 30px;
        margin: 0 30px;
      }

      .field {
        width: 140px;
      }
    }
  }

  .buttons {
    @include flex-center;
    width: 1300px;

    .macro-select {
      width: 150px;
      height: 42px;
      border: 1px solid $primary-color;
      border-radius: 5px;
      padding: 0 5px 0 10px;
      overflow: hidden;
      flex: none;
    }

    .macro-name,
    .all-time {
      width: 150px;
      margin-left: 40px;

      .input {
        width: 100%;
      }
    }

    .all-time {
      width: 100px;
    }

    .radio-group {
      flex: none;
      margin: 0 40px;

      .active {
        background: $primary-color;
        color: #ffffff;
      }
    }

    .progress {
      width: 200px;
      flex: none;
    }
  }
}
</style>
<style lang="scss">
.macro {
  .list .fields .field {
    .key-select {
      .md-input {
        font-size: 1em;
      }

      .md-icon {
        display: none;
      }
    }
    .key-input {
      width: 100%;
      height: 40px;
      line-height: 40px;
      max-width: 100%;
      display: block;
      cursor: pointer;
      font-size: 1em;
      border: 0;
      color: #ffffff;
      overflow: hidden;
    }
    .time-input {
      font-size: 1em;
    }

    &:hover .key-select {
      .md-icon {
        display: inline-flex;
      }
    }
  }

  .macro-field {
    width: auto;
    height: auto;
    min-height: auto;
    margin: 0;
    padding: 0;

    &::before,
    &::after {
      display: none;
    }
  }

  .progress {
    .ant-progress-inner {
      background-color: #333333;
    }
    .ant-progress-text {
      color: $primary-color;
    }
  }
}
</style>
